export default {"src":"/_next/static/media/speech-bubble.0cfd2e9c.svg","height":54,"width":47};